<template lang="html">
<div>
  <div class="header-container">
    <v-container class="parallax-container-center">
      <v-layout justify-center align-center class="header-layout">
        <v-flex xs12 sm10 md8 lg6 xl6>
          <h1 class="parallax-middle-header">Content is King</h1>

          <br>
          <p>KSG is proud to make social games that you can play on desktop and mobile devices and games for land-based casinos that you can play in Las Vegas and worldwide.</p>
        </v-flex>
      </v-layout>
    </v-container>
  </div>

  <section>
      <v-layout
        column
        wrap
        class="py-5"
        align-center
        xs10 offset-xs1
      >
        <v-flex xs12>
          <v-container grid-list-xs id="descriptionContainer">
            <v-layout row wrap align-start justify-center>
              <v-flex xs12 md10 class="ieFlex">
                <v-card class="elevation-0 transparent">
                  <!-- <v-card-text class="text-xs-center">
                    <v-icon x-large class="blue--text text--lighten-2">color_lens</v-icon>
                  </v-card-text> -->
                  <img
                    :src="landBased"
                    style="border-radius: 1rem; width: 70%;">
                  <v-card-title primary-title class="layout justify-center pb-1">
                    <div class="headline text-xs-center body-title"><span class="body-title">Land-Based Games</span></div>
                  </v-card-title>
                  <v-card-text class='description-section description-body' id="slot-games-text">
                    Played by millions of slot players in casinos across the globe.
                  </v-card-text>
                  <!-- <v-btn large color="#f38120" class="body-btn"><span class="header-btn-text">LEARN MORE</span></v-btn> -->
                  <v-btn outline round to="/land-based-games" color="#335091" class="body-btn">LEARN MORE</v-btn>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </section>
</div>
</template>

<script>
export default {
  data () {
    return {
      // lobster: require('../../assets/thumbnails/Thumbnail_Lobstermania.png'),
      // smvThumbnail: require('../../assets/thumbnails/Thumbnail_SMVS.png'),
      landBased: require('../../assets/thumbnails/Thumbnail_LandBased.png'),
      socialCasino: require('../../assets/thumbnails/Thumbnail_SocialCasinos.png'),
      windowWidth: 0,
      windowHeight: 0
    }
  },
  methods: {
    changeSocialHeight (event) {
      if (this.windowWidth >= 1264) {
        document.querySelector('#slot-games-text').style.height = '88px'
      } else if (this.windowWidth >= 960 && this.windowWidth < 1264) {
        document.querySelector('#slot-games-text').style.height = '160px'
      } else if (this.windowWidth >= 714 && this.windowWidth < 960) {
        document.querySelector('#slot-games-text').style.height = '52px'
      } else if (this.windowWidth >= 422 && this.windowWidth < 714) {
        document.querySelector('#slot-games-text').style.height = '88px'
      } else if (this.windowWidth >= 0 && this.windowWidth < 422) {
        document.querySelector('#slot-games-text').style.height = '124px'
      }
    },
    getWindowWidth (event) {
      this.windowWidth = window.innerWidth
    },
    getWindowHeight (event) {
      this.windowHeight = document.documentElement.clientHeight
    }
  },
  mounted () {
    this.$nextTick(function () {
      // window.addEventListener('resize', this.getWindowWidth)
      // window.addEventListener('resize', this.getWindowHeight)
      // window.addEventListener('resize', this.changeSocialHeight)
      //
      // // Init
      // this.getWindowWidth()
      // this.getWindowHeight()
      // this.changeSocialHeight()
    })

    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
      Array.from(document.querySelectorAll('.ieFlex')).forEach(function (el) {
        let docFrag = document.createDocumentFragment()
        while (el.firstChild) {
          let child = el.removeChild(el.firstChild)
          docFrag.appendChild(child)
        }

        // replace el with document fragment
        el.parentNode.replaceChild(docFrag, el)
      })

      this.footerHeight = parseInt(getComputedStyle(document.querySelector('#descriptionContainer')).height) + 30

      this.originalFooter = parseInt(getComputedStyle(document.querySelector('#footer')).height)
      document.querySelector('#footer').style.height = this.footerHeight + 'px'
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowWidth)
    window.removeEventListener('resize', this.getWindowHeight)
    window.removeEventListener('resize', this.changeSocialHeight)

    document.querySelector('#footer').style.height = this.originalFooter + 'px'
  }
}
</script>

<style lang="scss" scoped>
.header-container {
  background-image: url('../../assets/Header_Games.png');
}

.header-layout {
  margin: 2rem 0;
}

.parallax-container-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
}

.parallax-middle-header {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 2.7rem;
  align-self: stretch;
}

.body-title {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 700;
  font-size: 33px;
  color: #f6821f;
}

.description-body {
  padding-top: 0;
  font-family: lato, serif;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #222222;
}

.body-btn {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 20px;
  padding-left: 5rem;
  padding-right: 5rem;
}
</style>
